//import LocalizedStrings from 'react-localization';
import { getStrings } from '../Common/Localization/commonStrings';

const localizedStrings = {
  loginComponent: {
    strings: {
      en: {
        setupId: 'You can set up your User ID later.',
        newToSCE: 'New to SCE?',
        register: 'Register',
        registerNow: 'Register Now',
        started: 'Ready to get started?',
        loginUserId: 'Log in with your SCE.com User ID and password',
        Unregister: 'Not Registered Yet?',
        oniUnregister: 'New to SCE?',
        signup: 'To sign up or to manage existing alert preferences, please log in below.',
        outageAlert: 'By signing up for outage alerts, we will let you know - via email, text or phone - when there is an outage that impacts you and when you can expect your lights back on.',
        existingLogin: 'When you log in, your existing contact information in your SCE profile is available to choose from, so you dont have to type it all in again.',
        loginset: 'Why log in?',
        newAccount: 'Create New Account',
        continue: 'Continue',
        guestContinue: 'Continue As Guest',
        loginNow: 'Login Now',
        logIn: 'Log In',
        logging: 'Logging In...',
        rememberMe: 'Remember me',
        sessionInfo: 'sessionInfo',
        timeoutDialog: '5 minutes and 00 seconds',
        forgotPassword: 'Forgot your password?',
        resetPassword: 'Reset Password',
        loginSetup: 'To complete Setup, log in or continue as ',
        registerAccess: 'Register to easily access your account each time you return.',
        loginGlobalError: "We're sorry the username or password you entered does not match our records. Please re-enter your information and try again. If you continue to have issues, please try to \
        <a style='text-decoration:underline;' href='/user-registration'> Register </a>\
        your account or \
        <a style='text-decoration:underline;' href='/mysce/resetpassword'>Reset your Password.</a>",
        registerMessage: 'Register to easily view and pay your bills, review your usage, sign up for notifications, and more.',
        inactivityWarningMessage: 'For your security, your session has expired after a period of inactivity.',
        inactivityWarningActionMessage: 'Press OK to be redirected to the home page.',
        timedOutMessage: 'We have not detected any recent activity and your session is about to expire.',
        timedOutActionMessage: 'For your security, your session will expire in ',
        extend: 'Extend Session',
        lockedUser: 'For your security, we have locked your account due to too many attempts to Log In. Please contact SCE Customer Service at 1-800-284-2365.',
        ifYouLoginNow: 'If you login now, you will have to re-enter all of your information. Do you want to log in?',
        noCancelLogin: 'No, Cancel Login',
        yesLogin: 'Yes, Login',
        isCsrErrorMsg: 'We do not recognize the SCE.com User ID entered. Please contact us at 1-800-655-4555 to reset your password.',
        sessionSecurity: 'For your security, your session has expired after a period of inactivity.',
        sessionRedirected: 'Press OK to be redirected to the home page.',
        userTimeLimitError: 'Sorry, We are having some technical issues. Please try again in a few minutes.',
        guestUserPaymentError: 'Need to make a payment now?',
        payAsPerson: 'Pay In Person',
        payAsGuest: 'Pay As Guest',
        payByPhone: 'Pay By Phone:',
        loginNotRequired: '(log in not required)',
        loginWithSceMSg:'Log in with SCE.com User ID and Password',
        payBillLoginString: 'Log In to Your Account', 
        LogintoYourAccount: 'Log into SCE.com',
        email:'Email:',
        password:'Password:',
        payBillEmail:'Email',
        payBillPassWord:'Password', 
        newforgotPassword:'Forgot Password?',
        dnotHaveAnAccount:'Not registered for SCE.com?',
        registerHere: 'Register here',
        loginRegister: 'Log IN/Register',
        loginPeriodError: 'Your User ID is the email address you used to register with SCE.com.',
        userName:'userName',
        passWord:'password',
        resetPasswordUrl: 'mysce/resetpassword',
        turnon:'oto/movecenter/turnon',
        turnoff:'oto/movecenter/turnoff',
        transfer:'oto/movecenter/transfer',
        innerLoginUserNamelabletext:'User ID / Email',
        innerLoginPasswordlabletext:'Password',
        script:'javascript:void(13)',
        falseText:'false',
        loginSpinnerMessage:'Please give us a moment. Thanks for waiting',
        turnonPath:"/oto/movecenter/turnon",
        turnonPath1:"/oto/turnon",
        turnoffPath:"/oto/movecenter/turnoff",
        turnoffPath1:"/oto/turnoff",
        transferPath:"/oto/movecenter/transfer",
        transferPath1:"/oto/transfer",
        zipcode:"#zipCode",
        ConfirmationHash:"#confirmationPage",
        zipcodeTransfer:"#zipCodeTurnOff",
        loggedInServiceAddress:"#loggedInServiceAddress",
        textInline : 'inline',
        guestElement: 'react-centralized-guest'
      },
      es: {
        welcome: 'BIENVENIDO/A',
        LogintoYourAccount: 'Inicia sesión en tu cuenta',
        email:'Correo electrónico:',
        password:'Contraseña:',
        newforgotPassword:'¿Olvidaste tu contraseña?',
        dnotHaveAnAccount:'¿No tienes una cuenta?',
        registerHere: 'Regístrate aquí',
        logIn: 'Iniciar sesión',
        rememberMe: 'Recordar mis datos',
        loginRegister:'Iniciar sesión / Registrarse',
        logging:'Iniciando sesión…'
      },
      ko: {
        welcome: '환영',
        LogintoYourAccount: '계정에 로그인하기',
        email:'이메일:',
        password:'비밀번호:',
        newforgotPassword:'비밀번호를 분실하셨습니까?',
        dnotHaveAnAccount:'계정이 없으십니까?',
        registerHere: '등록하기',
        logIn: '로그인',
        rememberMe: '계정 기억하기',
        loginRegister:'로그인/등록',
        logging:'로그인…'
      },
      zh: {
        welcome: '歡迎',
        LogintoYourAccount: '登入您的帳戶',
        email:'電子郵件：',
        password:'密碼：',
        newforgotPassword:'忘記密碼？',
        dnotHaveAnAccount:'沒有帳戶？',
        registerHere: '在這裡註冊',
        logIn: '登入',
        rememberMe: '記住我的帳戶',
        loginRegister:'登入／註冊',
        logging:'正在登入…'
      },
      vi: {
        welcome: 'TIẾP RƯỚC',
        LogintoYourAccount: 'Đăng nhập vào Trương Mục của Quý Vị',
        email:'Email:',
        password:'Mật Khẩu:',
        newforgotPassword:'Quên mật khẩu?',
        dnotHaveAnAccount:'Không có trương mục?',
        registerHere: 'Ghi danh tại đây',
        logIn: 'Đăng Nhập',
        rememberMe: 'Hãy lưu lại để nhớ',
        loginRegister:'Đăng Nhập / Ghi Danh',
        logging:'Đang đăng nhập...'
      },
       km:{
        loginRegister:'ចូល/ចុះឈ្មោះ',
        logIn: 'ចូល' 
      },
      tl:{
        loginRegister:'Mag-log IN/Magrehistro',
        logIn: 'Mag-log IN'
      },
      ar:{
        loginRegister:'ورود/ثبت نام',
        logIn: 'وارد شدن'
      },
      hy:{
        loginRegister:'Մուտք գործեք / գրանցվեք',
        logIn: 'Մուտք գործեք'
      },
      fa:{
        loginRegister:'ورود/ثبت نام',
        logIn: 'وارد شدن'
      },
      fr:{
        loginRegister:"S'identifier S'enregistrer",
        logIn: "S'identifier"
      },
      ge:{
        loginRegister:'Anmeldung Registrieren',
        logIn: 'Anmeldung'
      },
      ja:{
        loginRegister:'ログイン/登録',
        logIn: 'ログイン'
      },
      pa:{
        loginRegister:'ਲੌਗ ਇਨ/ਰਜਿਸਟਰ ਕਰੋ',
        logIn: 'ਲੌਗ ਇਨ'
      },
      ru:{
        loginRegister:'Войти/Зарегистрироваться',
        logIn: 'Войти'
      },
      pt:{
        loginRegister:'Entrar/Registrar',
        logIn: 'Entrar'
       },
      hi:{
        loginRegister:'लॉग इन/रजिस्टर',
        logIn: 'लॉग इन'
      },
      hmn:{
        loginRegister:'Log IN/Register',
        logIn: 'Log IN'
      },
      th:{
        loginRegister:'เข้าสู่ระบบ/ลงทะเบียน',
        logIn: 'เข้าสู่ระบบ'
      },

    },
    common: ['login', 'cancel', 'welcome', 'ok', 'globalError']
  },
  logOutComponent: {
    strings: {
      en: {
         hiText:'Hi, ',
        close:'Close',
        myAccount: 'My Account ',
        logOut: 'Log Out ',
        benchMarkDashBoard: 'Benchmarking Dashboard',
        benchmarkLoggedInHeader: 'Create and manage properties and buildings in your profile to share your data.',
        myaccountButtonId:"myaccountButton"
      },
      es: {
        hiText: 'Hola, ',
        close:'Cerrar',
        myAccount: 'Mi cuenta ',
        logOut: 'Cerrar sesión '
      },
      ko: {
        hiText: '안녕하십니까, ',
        close:'닫기',
        myAccount: '나의 계정 ',
        logOut: '로그아웃 '
      },
      vi: {
        hiText: 'Xin chào, ',
        close:'Đóng',
        myAccount: 'Trương Mục của Tôi ',
        logOut: 'Đăng Xuất '
      },
      zh: {
        hiText: '[姓名]先生／女士，',
        close:'關閉',
        myAccount: '我的帳戶 ',
        logOut: '登出 '
      }
    },
    common: ['welcome']
  },
};

export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, "true");
  // app.logger.getLogger().info("Combined Set " + JSON.stringify(strings));
  return strings;
};
